function configure(Twig, translations) {
  return function i18n(key) {
    const obfuscate = (value) => {
      if (
        !this.context
        || !this.context.config
        || !this.context.config.obfuscate
      ) {
        return value;
      }

      const chars = [...value];
      const positions = [];
      const alphanumerics = [];

      chars.forEach((char, index) => {
        if (/[A-Za-z0-9]/.test(char)) {
          positions.push(index);
          alphanumerics.push(char);
        }
      });

      // Fisher–Yates shuffle
      for (let i = alphanumerics.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [alphanumerics[i], alphanumerics[j]] = [alphanumerics[j], alphanumerics[i]];
      }

      positions.forEach((pos, i) => {
        chars[pos] = alphanumerics[i];
      });

      return chars.join('');
    }

    if (typeof key !== 'string') {
      return key;
    }

    let translation = key;

    if (!key.startsWith('ui.') && !key.startsWith('backend.')) {
      key = `backend.${key}`;
    }

    this.context = this.context || {};
    this.context.year = this.context.year || `${(new Date()).getFullYear()}`;

    if (translations[key]) {
      translation = translations[key];

      Object.keys(this.context).forEach((key) => {
        const value = this.context[key];
        if (typeof value !== 'number' && typeof value !== 'string') {
          return;
        }

        translation = translation.split(`{${key}}`).join(value);
      });

      return obfuscate(translation.split('E-Points').join('E\u2011Points'));
    }

    if (
      this.context.config &&
      this.context.config.client &&
      this.context.config.language &&
      translations &&
      translations[this.context.config.client] &&
      translations[this.context.config.client][this.context.config.language] &&
      translations[this.context.config.client][this.context.config.language][key]
    ) {
      translation = translations[this.context.config.client][this.context.config.language][key];

      Object.keys(this.context).forEach((key) => {
        const value = this.context[key];
        if (typeof value !== 'number' && typeof value !== 'string') {
          return;
        }

        translation = translation.split(`{${key}}`).join(value);
      });

      return obfuscate(translation.split('E-Points').join('E\u2011Points'));
    }

    if (
      this.context.config &&
      this.context.config.language &&
      translations &&
      translations.common &&
      translations.common[this.context.config.language] &&
      translations.common[this.context.config.language][key]
    ) {
      translation = translations.common[this.context.config.language][key];

      Object.keys(this.context).forEach((key) => {
        const value = this.context[key];
        if (typeof value !== 'number' && typeof value !== 'string') {
          return;
        }

        translation = translation.split(`{${key}}`).join(value);
      });

      return obfuscate(translation.split('E-Points').join('E\u2011Points'));
    }

    if (translation && translation.split) {
      Object.keys(this.context).forEach((key) => {
        const value = this.context[key];
        if (typeof value !== 'number' && typeof value !== 'string') {
          return;
        }

        translation = translation.split(`{${key}}`).join(value);
      });
    }

    return obfuscate(translation.split('E-Points').join('E\u2011Points'));
  };
}

module.exports = configure;



// WEBPACK FOOTER //
// ./src/libs/twig/i18n/index.js